
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M3.5 11.9914C3.5 7.91806 6.36226 4.51335 10.1848 3.67877C9.88819 4.08715 9.63425 4.52639 9.4278 4.98974C9.03119 5.87986 8.81793 6.84074 8.80074 7.81506C8.78355 8.78938 8.96278 9.75719 9.32774 10.6607C9.6927 11.5643 10.2359 12.3851 10.925 13.0741C11.614 13.7632 12.4348 14.3064 13.3384 14.6714C14.2419 15.0363 15.2097 15.2156 16.184 15.1984C17.1584 15.1812 18.1192 14.9679 19.0094 14.5713C19.473 14.3647 19.9124 14.1106 20.321 13.8138C19.488 17.6373 16.0832 20.5 12.0095 20.5C7.30924 20.5 3.5 16.6907 3.5 11.9914Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiDarkFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
